import { ListItemButton, ListItemText } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { menuStyles } from 'src/components/shared/styles/MenuStyles'
import Link from 'src/components/shared/ui/Link'
import { ESCRITOS_LEXNET } from 'src/constants/routes'
import { TipoMensaje, TipoMensajeURLPath } from 'src/enums/EscritosLegales'

type iniciador = {
  name: string
  path: TipoMensajeURLPath
  type: TipoMensaje
}

type Props = {
  handleClose: (tipoMensaje: TipoMensaje) => void
}

export default function IniciadoresMenu({ handleClose }: Props): JSX.Element {
  const { t } = useTranslation()

  // const [openIniciadores, setIniciadoresOpen] = useState(false)
  const iniciadoresOptions: iniciador[] = [
    {
      name: t('navigation.iniciador_asunto'),
      path: TipoMensajeURLPath.ASUNTO,
      type: TipoMensaje.INICIADOR_ASUNTO
    },
    {
      name: t('navigation.monitorio'),
      path: TipoMensajeURLPath.MONITORIO,
      type: TipoMensaje.MONITORIO
    },
    {
      name: t('navigation.iniciador_ejecucion'),
      path: TipoMensajeURLPath.EJECUCION,
      type: TipoMensaje.INICIADOR_EJECUCION
    }
    // {
    //   name: t('navigation.iniciador_sentencia_firme'),
    //   path: TipoMensajeURLPath.SENTENCIA,
    //   type: TipoMensaje.INICIADOR_RECURSO_DE_REVISION_DE_SENTENCIA_FIRME
    // },
    // {
    //   name: t('navigation.iniciador_queja'),
    //   path: TipoMensajeURLPath.QUEJA,
    //   type: TipoMensaje.RECURSO_QUEJA
    // }
  ]

  function closeMenu(tipoMensaje: TipoMensaje) {
    handleClose(tipoMensaje)
    // setIniciadoresOpen(false)
  }

  /* function iniciadoresHandleClick() {
    setIniciadoresOpen(!openIniciadores)
  } */

  return (
    <>
      {iniciadoresOptions.map(option => (
        <Link key={option.name} to={ESCRITOS_LEXNET(option.path)}>
          <ListItemButton onClick={() => closeMenu(option.type)} sx={menuStyles.menuItem}>
            <ListItemText primary={option.name} />
            {/* <AngleRightIcon /> */}
          </ListItemButton>
        </Link>
      ))}
    </>
  )
}
